import {useAuthState} from "react-firebase-hooks/auth";
import {Redirect} from "react-router-dom";
import {auth} from "../firebase/index.js";
import APXAuthenticationForm from "./APXAuthenticationForm.jsx";
import APXFullHeightLoading from "./APXFullHeightLoading.jsx";
import {DASHBOARD} from "./js/AppRoutes.js";


export default function Home() {
	  
	  let [user, loading, error] = useAuthState(auth);
	  
	  
	  return (
				 <>
						{
							  loading ?
										 <APXFullHeightLoading/>
										 :
										 user === null ?
													<APXAuthenticationForm/>
													:
													<Redirect to={DASHBOARD.path}/>
						}
				 </>
	  );
}